import { IReport } from "../models/report.model";
import ResourceFactory from "./resource";

const resourceKey = "reports";
const resourceUrl = "reports";
const resourceIdKey = "id";

const { reducer, fetchList, fetch, create, remove } = ResourceFactory<IReport>(resourceKey, resourceUrl, resourceIdKey);

export type ReportResourcesState = ReturnType<typeof reducer>;

export const fetchReportsList = fetchList;
export const fetchAllReports = fetchList.bind(null, { page: 1, rows: 1000, sort: null });
export const fetchReport = fetch;
export const createReport = create;
export const removeReport = remove;

export default reducer;
